import { render, staticRenderFns } from "./RegistrantInfo.vue?vue&type=template&id=a1de7c96&"
import script from "./RegistrantInfo.vue?vue&type=script&lang=js&"
export * from "./RegistrantInfo.vue?vue&type=script&lang=js&"
import style0 from "./RegistrantInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports